module.exports = __webpack_public_path__ + "static/media/author_img_3.7b98bd41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/author_img_3.jpg
// module id = 283
// module chunks = 0